export const intercomAppId = 'if21xyrg'

/**
 * Every user belongs to the same Intercom company. Company ID and name are the
 * minimum Intercom requires, and grouping everyone under one company means the
 * team sees each other's tickets in the tickets portal instead of only their own.
 */
export const intercomCompany = {
  id: 'modugen',
  name: 'ModuGen',
}
